/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leaderboard_Pr_Type_PlaceholderInputs */

const fr_leaderboard_pr_type_placeholder = /** @type {(inputs: Leaderboard_Pr_Type_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionnez un type de RP...`)
};

/**

* @param {Leaderboard_Pr_Type_PlaceholderInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const leaderboard_pr_type_placeholder = /** @type {((inputs?: Leaderboard_Pr_Type_PlaceholderInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leaderboard_Pr_Type_PlaceholderInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_leaderboard_pr_type_placeholder(inputs)
});